import { useQuery } from "@tanstack/react-query";
import API from "@src/API";
import { queryKeys } from "./keys";

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

async function fetchResumePresentation(careerId) {
  const resp = await API.getAsync(`/Resume/${careerId}`);
  if (resp?.status === 404) {
    const err = new Error("Resume not found");
    err.code = "not_found";
    throw err;
  }
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || resp?.jsonData?.error || "Could not load resume");
  }
  const data = resp.jsonData || {};
  return {
    careerId: data.careerId ?? data.CareerId ?? careerId,
    format: Number(data.format ?? data.Format ?? 1),
    formatKey: data.formatKey || data.FormatKey || "classic",
    objective: data.objective ?? data.Objective ?? null,
    person: data.person || data.Person || {},
    location: data.location ?? data.Location ?? null,
    skills: asArray(data.skills ?? data.Skills),
    jobs: asArray(data.jobs ?? data.Jobs),
    education: asArray(data.education ?? data.Education),
    certifications: asArray(data.certifications ?? data.Certifications),
  };
}

export function useResumePresentationQuery(careerId, options = {}) {
  const id = Number(careerId) || 0;
  return useQuery({
    queryKey: queryKeys.resumePresentation(id),
    queryFn: () => fetchResumePresentation(id),
    enabled: id > 0,
    staleTime: 0,
    refetchOnMount: "always",
    ...options,
  });
}
